import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'

export default class OverlayingImages {
  containers = new LiveNodeList('.overlaying-images__blocks')

  mouseDown = false

  /**
   *
   */
  constructor() {
    if (this.containers.length === 0) {
      return
    }

    this.registerListeners()
  }

  @bind
  registerListeners() {
    this.containers.forEach(container => {
      const marker = container.querySelector('.overlaying-images__marker')
      if (marker) {
        container.addEventListener('mousemove', e => {
          if (this.mouseDown) {
            this.moveMarker(container, e.clientX)
          }
        })

        marker.addEventListener('touchmove', e => {
          const touch = e.touches[0] || e.changedTouches[0]
          if (this.mouseDown) {
            this.moveMarker(container, touch.clientX)
          }
        })

        marker.addEventListener('mousedown', () => {
          this.mouseDown = true
        })

        marker.addEventListener('touchstart', () => {
          this.mouseDown = true
        })

        marker.addEventListener('mouseup', e => {
          this.mouseDown = false
        })

        marker.addEventListener('touchend', () => {
          this.mouseDown = false
        })
      }
    })
  }

  @bind
  moveMarker(container, x) {
    const marker = container.querySelector('.overlaying-images__marker')
    const clipImage = container.querySelector(
      '.overlaying-images__block[data-block="1"]',
    )

    if (!marker || !clipImage) {
      return
    }

    //const left = marker.getBoundingClientRect().left
    const width = clipImage.getBoundingClientRect().width

    const percent = Math.min(95, Math.max((x / width) * 100, 5))

    clipImage.style.clipPath =
      'polygon(' + percent + '% 0, 100% 0, 100% 100%, ' + percent + '% 100%)'
    marker.style.left = 'calc(' + percent + '% - 1.875rem)'
  }
}
